import { Component } from '@angular/core';
import {
  NotificationProviderService,
  NotificationProviderTypeEnum
} from '../../external-interfaces/notification-provider.service';
import SlotService from '../../cart-process/slot.service';
import SlotModel from '../../models/slot.model';
import { CommonInfoService } from '../../cart-process/common-info.service';
import { slideInOut } from '../../utils/animations/slides.animation';
import { ICartDetails } from '../../interfaces/cart-details.interface';
import { IExtendedAdditionalBundleSet } from '../../interfaces/additional-bundles.interface';

@Component({
  selector: 'boho-side-order-details',
  templateUrl: './boho-side-order-details.component.html',
  animations: [slideInOut]
})
export class BohoSideOrderDetailsComponent {
  public bohoSlots: SlotModel[];
  public bohoOwnerSlot: SlotModel;
  public additionalBundles: IExtendedAdditionalBundleSet[];
  public isListVisible: boolean = false;
  public currencySymbol: string = 'zł';

  constructor(
    public commonInfo: CommonInfoService,
    private notificationProvider: NotificationProviderService,
    private slotService: SlotService,
  ) {
  }

  ngOnInit() {
    this.notificationProvider.subscribe(NotificationProviderTypeEnum.CART_DETAILS, (cartDetails: ICartDetails) => {
      if (cartDetails) {
        this.bohoSlots = this.slotService.getGroupedSlots().other;
        this.bohoOwnerSlot = this.slotService.getGroupedSlots().owner;
        this.additionalBundles = this.slotService.getAdditionalBundles();
      }
    });
  }
}
